<div class="tablePagination">

  <div class="tablePagination-dropdown">
    <div class="tablePagination-dropdownLabel">
      {{ "TABLE.ITEMS_PER_PAGE" | translate }}
    </div>
    <app-dropdown [options]="dropdownData.itemsPerPage" [labelKey]="'title'" [valueKey]="'value'"
      [mainForm]="form" [controlName]="controlName">
    </app-dropdown>
  </div>

  <div class="tablePagination-buttons">
    <button class="btn btn_link btn_iconOnly tablePagination-prev" (click)="previousPage()"
      [disabled]="isPrevPageDisabled" svgIcon [icon]="'arrow'"></button>
    <button class="btn btn_link btn_iconOnly tablePagination-next" (click)="nextPage()"
      [disabled]="isNextPageDisabled" svgIcon [icon]="'arrow'"></button>
  </div>

</div>
